import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { alpha, useTheme, emphasize, experimentalStyled as styled } from '@material-ui/core/styles';
import { Chip } from '@material-ui/core';
const ChipStyle = styled(Chip)(({ theme, styleProps, }) => {
    const { color, variant, clickable, onDelete } = styleProps;
    const styleFilled = (color) => ({
        color: theme.palette[color].contrastText,
        backgroundColor: theme.palette[color].main,
        '& .MuiChip-icon': { color: 'inherit' },
        '& .MuiChip-avatar': {
            backgroundColor: theme.palette[color].dark,
        },
        '& .MuiChip-deleteIcon': {
            color: alpha(theme.palette[color].contrastText, 0.7),
            '&:hover, &:active': { color: theme.palette[color].contrastText },
        },
    });
    const styleFilledClickable = (color) => ({
        '&:hover, &:focus': {
            backgroundColor: emphasize(theme.palette[color].main, theme.palette.action.hoverOpacity),
        },
    });
    const styleFilledDeletable = (color) => ({
        '&:focus': {
            backgroundColor: emphasize(theme.palette[color].main, theme.palette.action.focusOpacity),
        },
    });
    const styleOutlined = (color) => ({
        color: theme.palette[color].main,
        border: `1px solid ${theme.palette[color].main}`,
        '&:focus, &.MuiChip-clickable:hover': {
            backgroundColor: alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
        },
        '& .MuiChip-icon': { color: 'currentColor' },
        '& .MuiChip-avatar': {
            backgroundColor: theme.palette[color].dark,
        },
        '& .MuiChip-deleteIcon': {
            color: alpha(theme.palette[color].main, 0.7),
            '&:hover, &:active': { color: theme.palette[color].main },
        },
    });
    return {
        ...(variant === 'filled'
            ? {
                ...styleFilled(color),
                ...(clickable && { ...styleFilledClickable(color) }),
                ...(onDelete && { ...styleFilledDeletable(color) }),
            }
            : {
                ...styleOutlined(color),
            }),
    };
});
export const MChip = forwardRef(({ color = 'default', variant = 'filled', clickable: clickableProp, onDelete: onDeleteProp, ...other }, ref) => {
    const theme = useTheme();
    if (color === 'default' || color === 'primary' || color === 'secondary') {
        return (_jsx(Chip, Object.assign({ ref: ref, color: color, variant: variant, clickable: clickableProp && clickableProp, onDelete: onDeleteProp && onDeleteProp }, other), void 0));
    }
    return (_jsx(ChipStyle, Object.assign({ ref: ref, variant: variant, clickable: clickableProp && clickableProp, onDelete: onDeleteProp && onDeleteProp, styleProps: {
            color,
            variant,
            clickable: clickableProp && clickableProp,
            onDelete: onDeleteProp && onDeleteProp,
        }, theme: theme }, other), void 0));
});
//# sourceMappingURL=MChip.js.map